import { Suspense, useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { trackPage } from "@/lib/api";
import { clearBusy } from "@/lib/swr";
import { CompanyFilter, companyPage, syncActiveCompany } from "@/lib/company";
import { pageKeyForPath } from "@/context/AuthContext";

const lastTrack = { key: "", t: 0 };
import Sidebar from "./Sidebar";
import Header from "./Header";
import { Toaster } from "sonner";
import { cn } from "@/lib/utils";

export default function DashboardLayout() {
  const [collapsed, setCollapsed] = useState(false);
  const { pathname } = useLocation();
  const [coTick, setCoTick] = useState(0);
  const co = syncActiveCompany(pathname);
  useEffect(() => {
    const raw = pageKeyForPath(pathname);
    const key = raw === "admin" ? (pathname.startsWith("/users") ? "users" : null) : raw;
    if (!key || (lastTrack.key === key && Date.now() - lastTrack.t < 2000)) return;
    lastTrack.key = key; lastTrack.t = Date.now();
    trackPage(key);
    clearBusy();
  }, [pathname]);

  return (
    <div className="min-h-screen bg-[#080C14]">
      <Sidebar collapsed={collapsed} onToggle={() => setCollapsed(!collapsed)} />
      <div
        className={cn(
          "transition-all duration-300",
          collapsed ? "ml-[68px]" : "ml-64"
        )}
      >
        <Header />
        <main className="p-4 sm:p-6 lg:p-8">
          {companyPage(pathname) && <div className="-mt-2 mb-3"><CompanyFilter key={pathname} path={pathname} onChange={() => setCoTick(t => t + 1)} /></div>}
          <Suspense fallback={<div data-testid="page-loading" className="p-8 text-sm text-slate-500">Loading...</div>}><div key={`${coTick}:${co}`} className="contents"><Outlet /></div></Suspense>
        </main>
      </div>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#1E293B",
            border: "1px solid rgba(255,255,255,0.08)",
            color: "#F8FAFC",
          },
        }}
      />
    </div>
  );
}
